import { hasFilterParams } from "./urlUtils"

const BASE_URL = "https://achiscaffolding.com"
const SITE_NAME = "ACHI Scaffolding"

export const DEFAULT_SEO = {
  en: {
    title: "Construction & Industrial Scaffolding Systems | ACHI Scaffolding",
    description:
      "ACHI Scaffolding delivers access systems, shoring, and scaffolding solutions for construction, restoration, and industrial projects. Request technical consultation.",
  },
  fr: {
    title: "Entreprise d'échafaudage au Liban | ACHI",
    description:
      "ACHI Scaffolding fournit des systèmes d'accès, d'étaiement et d'échafaudage pour la construction, la restauration et les sites industriels au Liban.",
  },
  ar: {
    title: "عشي للسقالات | شركة سقالات في لبنان",
    description:
      "تقدم ACHI Scaffolding خدمات السقالات وأنظمة الوصول والتدعيم للمشاريع الإنشائية والصناعية وأعمال الترميم في لبنان.",
  },
  it: {
    title: "Ponteggi e Opere Provvisionali in Italia | ACHI Servizi e Appalti",
    description:
      "ACHI Servizi e Appalti: noleggio e montaggio ponteggi, manodopera specializzata, restauro e opere provvisionali in tutta Italia. Conformi Legge 198/2025. Preventivo 331 800 7652.",
  },
  ogImage: `${BASE_URL}/assets/ArchiScaffoldinglogo.png`,
  siteName: SITE_NAME,
}

export const ROUTE_SEO_CONFIG = {
  "/": {
    en: {
      title: "Scaffolding Company in Lebanon | ACHI Scaffolding",
      description:
        "Professional scaffolding services in Lebanon: access systems, shoring, and engineered solutions for construction, restoration, and industrial projects.",
      keywords: "scaffolding Lebanon, scaffolding company Lebanon, temporary works contractor Lebanon, facade scaffolding Lebanon, suspended scaffolding Lebanon, shoring Lebanon, propping systems Lebanon, construction scaffolding Beirut, industrial scaffolding Lebanon, scaffolding rental Lebanon, scaffolding installation Lebanon, access scaffolding systems, ACHI Scaffolding",
    },
    fr: {
      title: "Entreprise d'échafaudage au Liban | ACHI",
      description:
        "Services d'échafaudage au Liban : systèmes d'accès, étaiement et solutions techniques pour la construction, la restauration et l'industrie.",
      keywords: "échafaudage Liban, entreprise échafaudage Liban, entrepreneur travaux temporaires Liban, échafaudage de façade, échafaudage suspendu, étaiement Liban, location échafaudage Liban, installation échafaudage Liban, systèmes d'accès construction, échafaudage industriel Liban, échafaudage Beyrouth, ACHI Scaffolding",
    },
    ar: {
      title: "عشي للسقالات | شركة سقالات في لبنان",
      description:
        "خدمات سقالات في لبنان: أنظمة وصول، تدعيم وشدات، وحلول هندسية لمشاريع البناء والترميم والصناعة.",
      keywords: "سقالات لبنان, شركة سقالات لبنان, مقاول أعمال مؤقتة, سقالات واجهات, سقالات معلقة, تدعيم لبنان, دعامات قابلة للضبط, تأجير سقالات لبنان, تركيب سقالات لبنان, شدات معدنية, سقالات صناعية لبنان, سقالات بيروت, عشي للسقالات",
    },
    it: {
      title: "Ponteggi & Opere Provvisionali in Italia | ACHI Servizi e Appalti",
      description:
        "Noleggio e montaggio ponteggi, manodopera specializzata e opere provvisionali in tutta Italia. Conformi normative 2026 e Legge 198/2025. Sede Roma. Preventivo 331 800 7652.",
      keywords: "ponteggi Italia, noleggio ponteggi Italia, montaggio ponteggi Roma, ponteggi facciate, ponteggi sospesi, opere provvisionali, puntellamento strutturale, manodopera specializzata ponteggi, subappalto ponteggi, ACHI Servizi e Appalti, Legge 198/2025",
    },
    indexable: true,
  },

  "/about": {
    en: {
      title: "About Us | ACHI Scaffolding",
      description:
        "Learn about ACHI Scaffolding, a leading provider of construction and industrial scaffolding systems, access solutions, and technical expertise.",
      keywords: "about ACHI Scaffolding, ACHI SAL Lebanon, scaffolding company Lebanon, scaffolding contractor Beirut, scaffolding Dbayeh, facade scaffolding Lebanon, suspended scaffolding Lebanon, shoring Lebanon, temporary works contractor Lebanon, engineering-led scaffolding, scaffolding construction Lebanon, scaffolding restoration Lebanon",
    },
    fr: {
      title: "À propos | ACHI",
      description:
        "Découvrez ACHI Scaffolding, entreprise d'échafaudage au Liban spécialisée en solutions d'accès, d'étaiement et expertise technique.",
      keywords: "à propos ACHI Scaffolding, ACHI SAL Liban, entreprise échafaudage Liban, entrepreneur échafaudage Beyrouth, échafaudage Dbayeh, échafaudage de façade Liban, échafaudage suspendu Liban, étaiement Liban, travaux temporaires Liban, expertise technique échafaudage, échafaudage construction Liban, échafaudage restauration Liban",
    },
    ar: {
      title: "من نحن | عشي للسقالات",
      description:
        "تعرف على ACHI Scaffolding شركة سقالات في لبنان تقدم حلول الوصول والتدعيم وخبرة فنية للمشاريع الصناعية والإنشائية.",
      keywords: "من نحن عشي للسقالات, عشي للسقالات SAL لبنان, شركة سقالات لبنان, مقاول سقالات بيروت, سقالات ضبية لبنان, سقالات واجهات لبنان, سقالات معلقة لبنان, تدعيم لبنان, مقاول أعمال مؤقتة لبنان, خبرة هندسية سقالات, سقالات بناء لبنان, سقالات ترميم لبنان",
    },
    indexable: true,
  },

  "/chi-siamo": {
    it: {
      title: "Chi Siamo | ACHI Servizi e Appalti – Ponteggi, Restauro e Servizi Edili in Italia",
      description:
        "ACHI Servizi e Appalti: noleggio e montaggio ponteggi, manodopera specializzata, supporto restauro monumentale e interno in tutta Italia. Certificati INAIL – conformi Legge 198/2025. Sede Roma. Preventivo 331 800 7652.",
      canonical: "/it/chi-siamo",
      keywords: "chi siamo ACHI, ponteggi Italia, restauro monumentale, servizi edili Roma, INAIL, Legge 198/2025",
    },
    indexable: true,
  },

  "/services": {
    en: {
      title: "Scaffolding Services | ACHI Scaffolding",
      description:
        "Scaffolding installation, dismantling, supervision, rental, and engineered temporary works for construction and industrial projects.",
      keywords: "scaffolding services Lebanon, facade scaffolding installation, suspended scaffolding rental, propping and shoring services, indoor scaffolding, high-rise scaffolding, dome scaffolding, circular scaffolding, event scaffolding, industrial scaffolding, roof scaffolding, mobile suspended scaffolding bridges, scaffolding access stairs, loading unloading platforms, scaffolding design Lebanon, ACHI Scaffolding",
    },
    fr: {
      title: "Services d'échafaudage | ACHI",
      description:
        "Montage, démontage, supervision, location d'échafaudages, étaiement et solutions de travaux temporaires pour chantiers et sites industriels.",
      keywords: "services échafaudage Liban, montage échafaudage, démontage échafaudage, location échafaudage, étaiement Liban, travaux temporaires Liban, échafaudage façade, échafaudage suspendu, échafaudage intérieur, échafaudage dôme, ACHI Scaffolding",
    },
    ar: {
      title: "خدمات السقالات | عشي للسقالات",
      description:
        "تركيب وفك وإشراف وتأجير السقالات، وخدمات التدعيم وأعمال مؤقتة هندسية للمشاريع الإنشائية والصناعية.",
      keywords: "خدمات سقالات لبنان, تركيب سقالات, فك سقالات, تأجير سقالات, تدعيم لبنان, أعمال مؤقتة, سقالات واجهات, سقالات معلقة, سقالات داخلية, سقالات قباب, عشي للسقالات",
    },
    indexable: true,
  },

  "/servizi": {
    it: {
      title: "Servizi Ponteggi in Italia | ACHI Servizi e Appalti",
      description:
        "Servizi di ponteggi e opere provvisionali in Italia: noleggio a caldo, noleggio a freddo, ponteggi sospesi, facciate, eventi, sicurezza e manodopera specializzata.",
      canonical: "/it/servizi",
      keywords: "servizi ponteggi, noleggio ponteggi Italia, ponteggi sospesi, noleggio a caldo, noleggio a freddo, sicurezza cantiere",
    },
    indexable: true,
  },

  "/services/serviceItem": {
    en: {
      title: "Scaffolding Service | ACHI Scaffolding",
      description: "Service details for our scaffolding and temporary works solutions.",
      keywords: "scaffolding service details, temporary works, access solutions",
    },
    fr: {
      title: "Service d'échafaudage | ACHI",
      description: "Détails du service : échafaudage, accès temporaire, étaiement et travaux temporaires.",
      keywords: "service échafaudage, accès temporaire, étaiement",
    },
    ar: {
      title: "خدمة سقالات | عشي للسقالات",
      description: "تفاصيل الخدمة ضمن حلول السقالات وأنظمة الوصول والتدعيم والأعمال المؤقتة.",
      keywords: "خدمة سقالات, أنظمة وصول, تدعيم",
    },
    indexable: false,
  },

  "/projects": {
    en: {
      title: "Our Projects | ACHI Scaffolding",
      description: "Explore our scaffolding project portfolio across construction, restoration, and industrial sectors.",
      keywords: "scaffolding projects Lebanon, ACHI Scaffolding portfolio, construction projects Beirut, facade scaffolding projects Lebanon, suspended scaffolding projects, dome scaffolding projects Lebanon, church scaffolding Lebanon, restoration scaffolding projects, industrial scaffolding projects Lebanon, event scaffolding projects, temporary works projects Lebanon, scaffolding Dbayeh portfolio",
    },
    fr: {
      title: "Projets | ACHI",
      description: "Réalisations en échafaudage pour la construction, la restauration et la maintenance industrielle.",
      keywords: "projets échafaudage Liban, portfolio ACHI Scaffolding, réalisations construction Beyrouth, échafaudage de façade projets Liban, échafaudage suspendu projets, dôme échafaudage Liban, échafaudage église Liban, restauration échafaudage projets, projets industriels échafaudage Liban, échafaudage événements projets, travaux temporaires réalisations Liban",
    },
    ar: {
      title: "المشاريع | عشي للسقالات",
      description: "استعرض مشاريع السقالات في البناء والترميم والصيانة الصناعية.",
      keywords: "مشاريع سقالات لبنان, معرض أعمال عشي للسقالات, مشاريع بناء بيروت, مشاريع سقالات واجهات لبنان, مشاريع سقالات معلقة, مشاريع سقالات قباب لبنان, سقالات كنائس لبنان, مشاريع ترميم سقالات, مشاريع صناعية سقالات لبنان, مشاريع سقالات فعاليات, مشاريع أعمال مؤقتة لبنان",
    },
    indexable: true,
  },

  "/i-nostri-lavori": {
    it: {
      title: "I Nostri Lavori | Progetti Ponteggi e Restauro in Italia | ACHI",
      description:
        "Scopri i lavori ACHI in Italia: ponteggi per restauro, edifici storici, cantieri complessi, opere provvisionali e interventi tecnici specializzati.",
      canonical: "/it/i-nostri-lavori",
      keywords: "lavori ponteggi Italia, restauro edifici storici, cantieri ponteggi, opere provvisionali Roma",
    },
    indexable: true,
  },

  "/sectors": {
    en: {
      title: "Industry Sectors | ACHI Scaffolding",
      description: "Construction, restoration, industrial maintenance, infrastructure, and events.",
      keywords: "scaffolding sectors Lebanon, renovation scaffolding, construction scaffolding, dome scaffolding Lebanon, church scaffolding, event scaffolding Lebanon, industrial scaffolding Lebanon, oil and gas scaffolding, marine scaffolding, offshore scaffolding, infrastructure scaffolding, ACHI Scaffolding",
    },
    fr: {
      title: "Secteurs | ACHI",
      description: "Construction, restauration, maintenance industrielle, infrastructures et événements.",
      keywords: "secteurs échafaudage Liban, construction Liban, restauration patrimoine, maintenance industrielle, infrastructures Liban, échafaudage événements, échafaudage dôme, échafaudage église Liban, échafaudage offshore, ACHI",
    },
    ar: {
      title: "القطاعات | عشي للسقالات",
      description: "البناء والترميم والصيانة الصناعية والبنية التحتية والفعاليات.",
      keywords: "قطاعات سقالات لبنان, بناء لبنان, ترميم التراث, صيانة صناعية, بنية تحتية لبنان, سقالات فعاليات, سقالات قباب, سقالات كنائس لبنان, سقالات بحرية, عشي للسقالات",
    },
    indexable: true,
  },

  "/settori-applicazioni": {
    it: {
      title: "Settori di Applicazione | Dove Usiamo i Nostri Ponteggi in Italia – ACHI",
      description:
        "Settori in cui operiamo con ponteggi, impalcature e manodopera: condomini, restauro monumentale, edifici occupati, eventi, industria, cantieri navali. Soluzioni certificate 2026. Preventivo 331 800 7652.",
      canonical: "/it/settori-applicazioni",
      keywords: "settori ponteggi, restauro monumentale, condomini ponteggi, eventi ponteggi, industria ponteggi, cantieri navali",
    },
    indexable: true,
  },

  "/gallery": {
    en: {
      title: "Project Gallery | ACHI Scaffolding",
      description: "Scaffolding installations and project highlights.",
      keywords: "scaffolding gallery Lebanon, ACHI Scaffolding project photos, facade scaffolding photos Beirut, suspended scaffolding images Lebanon, dome scaffolding Lebanon, church scaffolding Lebanon, industrial scaffolding gallery, restoration scaffolding photos, event scaffolding images, scaffolding installation Dbayeh, temporary works gallery Lebanon",
    },
    fr: {
      title: "Galerie | ACHI",
      description: "Installations d'échafaudage et projets réalisés.",
      keywords: "galerie échafaudage Liban, photos projets ACHI Scaffolding, échafaudage de façade photos Beyrouth, échafaudage suspendu images Liban, dôme échafaudage Liban, échafaudage église Liban, galerie industrielle échafaudage, photos restauration échafaudage Liban, images échafaudage événements, installation échafaudage Dbayeh, galerie travaux temporaires Liban",
    },
    ar: {
      title: "المعرض | عشي للسقالات",
      description: "صور تركيبات السقالات وأبرز المشاريع.",
      keywords: "معرض سقالات لبنان, صور مشاريع عشي للسقالات, صور سقالات واجهات بيروت, صور سقالات معلقة لبنان, سقالات قباب لبنان, سقالات كنائس لبنان, معرض سقالات صناعية, صور ترميم سقالات لبنان, صور سقالات فعاليات, تركيب سقالات ضبية لبنان, معرض أعمال مؤقتة لبنان",
    },
    indexable: true,
  },

  "/blog": {
    en: {
      title: "Blog | ACHI Scaffolding",
      description: "Insights on scaffolding systems, temporary works, safety, and execution.",
      keywords: "scaffolding blog Lebanon, ACHI Scaffolding blog, construction industry insights Lebanon, temporary works Lebanon guide, scaffolding safety tips Lebanon, facade scaffolding articles, suspended scaffolding knowledge, scaffolding regulations Lebanon, construction site safety Lebanon, scaffolding contractor insights Beirut",
    },
    fr: {
      title: "Blog | ACHI",
      description: "Conseils et informations sur l'échafaudage, les travaux temporaires et la sécurité chantier.",
      keywords: "blog échafaudage Liban, ACHI Scaffolding blog, conseils construction Liban, guide travaux temporaires Liban, sécurité chantier échafaudage Liban, articles échafaudage façade, connaissances échafaudage suspendu, réglementation échafaudage Liban, sécurité site construction Beyrouth, conseils entrepreneur échafaudage",
    },
    ar: {
      title: "المدونة | عشي للسقالات",
      description: "مقالات عن السقالات والأعمال المؤقتة والسلامة والتنفيذ في الموقع.",
      keywords: "مدونة سقالات لبنان, مدونة عشي للسقالات, مقالات بناء لبنان, دليل أعمال مؤقتة لبنان, نصائح سلامة السقالات لبنان, مقالات سقالات واجهات, معرفة سقالات معلقة, تنظيم السقالات لبنان, سلامة موقع البناء بيروت, نصائح مقاول سقالات",
    },
    it: {
      title: "Blog Ponteggi Italia | ACHI Servizi e Appalti",
      description:
        "Approfondimenti su ponteggi, sicurezza, normativa, restauro e opere provvisionali in Italia.",
      canonical: "/it/blog",
      keywords: "blog ponteggi, sicurezza cantiere, normativa ponteggi Italia, restauro, opere provvisionali",
    },
    indexable: true,
  },

  "/blog-post-1": {
    en: {
      title: "Scaffolding in Lebanon: Industry Challenges and the Lack of Formal Regulation | ACHI Blog",
      description: "An in-depth look at the scaffolding industry in Lebanon, the absence of formal regulation, and what engineering-led practices can do to fill the gap.",
      keywords: "scaffolding Lebanon regulation, scaffolding standards Lebanon, scaffolding industry Lebanon, construction safety Lebanon, scaffolding compliance, temporary works Lebanon, engineering-led scaffolding",
    },
    fr: {
      title: "Échafaudage au Liban : défis du secteur et absence de réglementation formelle | Blog ACHI",
      description: "Un regard approfondi sur le secteur de l'échafaudage au Liban, l'absence de réglementation formelle et le rôle des pratiques d'ingénierie pour y remédier.",
      keywords: "réglementation échafaudage Liban, normes échafaudage Liban, industrie échafaudage Liban, sécurité construction Liban, conformité échafaudage, travaux temporaires Liban, ingénierie échafaudage",
    },
    ar: {
      title: "السقالات في لبنان: تحديات القطاع وغياب التنظيم الرسمي | مدونة ACHI",
      description: "نظرة معمّقة على قطاع السقالات في لبنان وغياب التنظيم الرسمي وما يمكن للممارسات الهندسية أن تقدمه لسدّ هذه الفجوة.",
      keywords: "تنظيم سقالات لبنان, معايير سقالات, صناعة سقالات لبنان, سلامة البناء لبنان, الامتثال للسقالات, أعمال مؤقتة لبنان, سقالات هندسية",
    },
    indexable: true,
  },

  "/blog-post-2": {
    en: {
      title: "What Are Temporary Works in Construction? | ACHI Blog",
      description: "A clear explanation of temporary works in construction: what they are, why they matter, and how shoring, propping, formwork, and scaffolding fit into the picture.",
      keywords: "temporary works construction, what are temporary works, temporary works definition, shoring systems, propping systems, formwork, scaffolding temporary works, construction site safety",
    },
    fr: {
      title: "Que sont les travaux temporaires en construction ? | Blog ACHI",
      description: "Une explication claire des travaux temporaires en construction : ce qu'ils sont, pourquoi ils comptent, et comment l'étaiement, le puntage, le coffrage et l'échafaudage s'inscrivent dans ce contexte.",
      keywords: "travaux temporaires construction, définition travaux temporaires, étaiement, systèmes de puntage, coffrage, sécurité chantier, échafaudage temporaire, Liban",
    },
    ar: {
      title: "ما هي الأعمال المؤقتة في البناء؟ | مدونة ACHI",
      description: "شرح واضح للأعمال المؤقتة في البناء: ما هي ولماذا تهم وكيف تندرج أنظمة التدعيم والدعامات والقوالب والسقالات في هذا الإطار.",
      keywords: "أعمال مؤقتة في البناء, ما هي الأعمال المؤقتة, تعريف أعمال مؤقتة, أنظمة التدعيم, دعامات, قوالب خرسانية, سقالات أعمال مؤقتة, سلامة موقع البناء",
    },
    indexable: true,
  },

  "/blog-post-3": {
    en: {
      title: "Scaffolding for Occupied Buildings: Safe Access Without Disrupting Operations | ACHI Blog",
      description: "How ACHI Scaffolding installs and manages scaffolding on occupied residential and commercial buildings while keeping tenants safe and operations running.",
      keywords: "scaffolding occupied buildings, scaffolding residential buildings, safe access scaffolding, scaffolding without disruption, construction access occupied site, scaffolding tenants safety, scaffolding installation planning",
    },
    fr: {
      title: "Échafaudage pour bâtiments occupés : accès sécurisé sans perturber l'exploitation | Blog ACHI",
      description: "Comment ACHI Scaffolding installe et gère les échafaudages sur des bâtiments résidentiels et commerciaux occupés, en préservant la sécurité des occupants et la continuité d'exploitation.",
      keywords: "échafaudage bâtiments occupés, accès sécurisé échafaudage, échafaudage résidentiel, travaux sans perturbation, sécurité locataires, planification installation échafaudage, Liban",
    },
    ar: {
      title: "سقالات المباني المشغولة: وصول آمن دون تعطيل التشغيل | مدونة عَشي للسقالات",
      description: "كيف تقوم عشي للسقالات بتركيب وإدارة السقالات على المباني السكنية والتجارية المشغولة مع الحفاظ على سلامة السكان واستمرارية العمليات.",
      keywords: "سقالات مبانٍ مأهولة, وصول آمن للسقالات, سقالات مباني سكنية, أعمال بدون تعطيل, سلامة المستأجرين, تخطيط تركيب السقالات, لبنان",
    },
    indexable: true,
  },

  "/blog/normative-ponteggi-2026-legge-198-2025-badge-cantiere": {
    it: {
      title: "Normative Ponteggi 2026: Legge 198/2025 e Badge di Cantiere | Blog ACHI",
      description: "Guida completa alle nuove normative ponteggi 2026 in Italia: Legge 198/2025, badge di cantiere obbligatorio, requisiti INAIL e impatti pratici per imprese e subappaltatori.",
      canonical: "/it/blog/normative-ponteggi-2026-legge-198-2025-badge-cantiere",
      keywords: "normative ponteggi 2026, Legge 198/2025, badge cantiere, INAIL ponteggi, subappalto ponteggi Italia, sicurezza ponteggi 2026",
    },
    indexable: true,
  },

  "/blog/come-scegliere-impalcature-per-restauro": {
    it: {
      title: "Come Scegliere le Impalcature per il Restauro | Blog ACHI",
      description: "Guida tecnica alla scelta delle impalcature per interventi di restauro monumentale e conservativo in Italia: tipologie, normative, sicurezza e criteri di selezione del partner.",
      canonical: "/it/blog/come-scegliere-impalcature-per-restauro",
      keywords: "impalcature restauro Italia, ponteggi restauro monumentale, scelta ponteggi restauro, restauro conservativo ponteggi, sicurezza impalcature restauro",
    },
    indexable: true,
  },

  "/careers": {
    en: {
      title: "Careers | ACHI Scaffolding",
      description:
        "Explore career opportunities at ACHI Scaffolding. Join a professional scaffolding company and temporary works contractor delivering complex projects across Lebanon.",
      canonical: "/careers",
      keywords: "scaffolding careers Lebanon, ACHI Scaffolding jobs, construction jobs Beirut Lebanon, scaffolding technician jobs Lebanon, rigger jobs Lebanon, temporary works employment Lebanon, scaffolding engineer Lebanon, facade scaffolding installer jobs, scaffolding Dbayeh employment, join ACHI Scaffolding team",
    },
    fr: {
      title: "Carrières | ACHI",
      description:
        "Découvrez les opportunités de carrière chez ACHI Scaffolding. Rejoignez une entreprise d'échafaudage et de travaux temporaires au Liban.",
      canonical: "/fr/careers",
      keywords: "carrières échafaudage Liban, emploi ACHI Scaffolding, emplois construction Beyrouth Liban, technicien échafaudage emploi Liban, rigger emploi Liban, emploi travaux temporaires Liban, ingénieur échafaudage Liban, monteur échafaudage façade emploi, emploi Dbayeh construction, rejoindre ACHI Scaffolding",
    },
    ar: {
      title: "الوظائف | عشي للسقالات",
      description:
        "استكشف فرص العمل لدى عشي للسقالات. انضم إلى شركة سقالات ومقاول أعمال مؤقتة ينفذ مشاريع معقدة في لبنان.",
      canonical: "/lb/careers",
      keywords: "وظائف سقالات لبنان, وظائف عشي للسقالات, فرص عمل بناء بيروت لبنان, وظائف فني سقالات لبنان, وظائف مراقبة بناء لبنان, وظائف أعمال مؤقتة لبنان, وظائف مهندس سقالات لبنان, وظائف تركيب سقالات واجهات, توظيف ضبية بناء, انضم إلى عشي للسقالات",
    },
    indexable: true,
  },

  "/lavora-con-noi": {
    it: {
      title: "Lavora con Noi | Diventa Partner ACHI – Subappaltatori, Montatori, Trasportatori, Restauratori",
      description:
        "Entra nel network ACHI Servizi e Appalti. Registra la tua azienda e ricevi progetti in tutta Italia. Vantaggi: pagamenti puntuali, lavoro costante e burocrazia semplificata.",
      canonical: "/it/lavora-con-noi",
      keywords: "lavora con noi ponteggi, partner ACHI, subappaltatori Italia, montatori ponteggi, lavoro ponteggi Roma",
    },
    indexable: true,
  },

  "/careers/partner": {
    en: {
      title: "Partner Registration | ACHI",
      description: "Partner registration is available in Italian.",
      canonical: "/careers/partner",
      keywords: "partner registration, ACHI partner",
    },
    fr: {
      title: "Partenariat | ACHI",
      description: "Inscription partenaire disponible en italien.",
      canonical: "/fr/careers/partner",
      keywords: "partenariat ACHI, inscription partenaire",
    },
    ar: {
      title: "التسجيل كشريك | عشي",
      description: "التسجيل كشريك متاح بالإيطالية.",
      canonical: "/lb/careers/partner",
      keywords: "تسجيل شريك, عشي شراكة",
    },
    indexable: false,
  },

  "/lavora-con-noi-partner": {
    it: {
      title: "Partner ACHI | Registrazione Partner Italia",
      description:
        "Registrazione partner ACHI per subappaltatori, montatori, trasportatori, restauratori, progettisti e professionisti del settore ponteggi in Italia.",
      canonical: "/it/lavora-con-noi-partner",
      keywords: "registrazione partner ponteggi, subappaltatori Italia, montatori, trasportatori, restauratori",
    },
    indexable: false,
  },

  "/privacy-policy": {
    en: {
      title: "Privacy Policy | ACHI Scaffolding",
      description: "Read the ACHI Scaffolding privacy policy. Learn how we collect, use, and protect your personal data.",
      keywords: "privacy policy, data protection, ACHI Scaffolding privacy",
    },
    fr: {
      title: "Politique de confidentialité | ACHI",
      description: "Consultez la politique de confidentialité d'ACHI Scaffolding. Découvrez comment nous collectons et protégeons vos données.",
      keywords: "politique de confidentialité, protection des données, ACHI",
    },
    ar: {
      title: "سياسة الخصوصية | عشي للسقالات",
      description: "اقرأ سياسة الخصوصية لعشي للسقالات. تعرف على كيفية جمع واستخدام وحماية بياناتك الشخصية.",
      keywords: "سياسة الخصوصية, حماية البيانات, عشي للسقالات",
    },
    it: {
      title: "Informativa sulla Privacy | ACHI Servizi e Appalti",
      description: "Informativa sulla privacy di ACHI Servizi e Appalti. Come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali.",
      canonical: "/it/privacy-policy",
      keywords: "informativa privacy, protezione dati, ACHI Servizi e Appalti, GDPR",
    },
    indexable: true,
  },
}

export const NOINDEX_PATTERNS = [/^\/admin/, /^\/login/, /^\/dashboard/, /^\/cart/, /^\/checkout/, /^\/thank-you/]

const slugToLabel = (slug = "") =>
  String(slug)
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()

const capitalizeWords = (value = "") =>
  String(value)
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")

const buildDynamicSeo = (pathname, lang = "en") => {
  const p = String(pathname || "")

  if (/^\/services\/[^/]+$/i.test(p)) {
    const slug = p.split("/").pop() || ""
    const label = capitalizeWords(slugToLabel(slug))

    if (lang === "fr") {
      return {
        title: `${label} | Services d'échafaudage | ACHI`,
        description: `Découvrez le service ${slugToLabel(slug)} proposé par ACHI pour les chantiers, l'industrie et les travaux temporaires au Liban.`,
        canonical: p,
      }
    }

    if (lang === "ar") {
      return {
        title: `${label} | خدمات السقالات | عشي للسقالات`,
        description: `تعرف على خدمة ${slugToLabel(slug)} ضمن حلول السقالات والأعمال المؤقتة التي تقدمها ACHI Scaffolding في لبنان.`,
        canonical: p,
      }
    }

    return {
      title: `${label} | Scaffolding Services | ACHI Scaffolding`,
      description: `Explore ${slugToLabel(slug)} services from ACHI Scaffolding for construction, industrial access, and temporary works projects in Lebanon.`,
      canonical: p,
    }
  }

  if (/^\/project\/[^/]+$/i.test(p)) {
    const slug = p.split("/").pop() || ""
    const label = capitalizeWords(slugToLabel(slug))

    if (lang === "fr") {
      return {
        title: `${label} | Projet | ACHI`,
        description: `Découvrez le projet ${slugToLabel(slug)} réalisé par ACHI dans le domaine de l'échafaudage et des travaux temporaires au Liban.`,
        canonical: p,
      }
    }

    if (lang === "ar") {
      return {
        title: `${label} | مشروع | عشي للسقالات`,
        description: `استعرض مشروع ${slugToLabel(slug)} الذي نفذته ACHI Scaffolding ضمن أعمال السقالات والحلول المؤقتة في لبنان.`,
        canonical: p,
      }
    }

    return {
      title: `${label} | Project | ACHI Scaffolding`,
      description: `Explore the ${slugToLabel(slug)} project delivered by ACHI Scaffolding across construction, restoration, and temporary works in Lebanon.`,
      canonical: p,
    }
  }

  if (/^\/servizi\/[^/]+$/i.test(p)) {
    const slug = p.split("/").pop() || ""
    const label = capitalizeWords(slugToLabel(slug))

    return {
      title: `${label} | Servizi Ponteggi Italia | ACHI`,
      description: `Scopri il servizio ${slugToLabel(slug)} di ACHI Servizi e Appalti per ponteggi, opere provvisionali e cantieri complessi in Italia.`,
      canonical: `/it${p}`,
    }
  }

  if (/^\/i-nostri-lavori\/[^/]+$/i.test(p)) {
    const slug = p.split("/").pop() || ""
    const label = capitalizeWords(slugToLabel(slug))

    return {
      title: `${label} | Progetto Ponteggi Italia | ACHI`,
      description: `Scopri il progetto ${slugToLabel(slug)} realizzato da ACHI Servizi e Appalti in Italia per ponteggi, restauro e opere provvisionali.`,
      canonical: `/it${p}`,
    }
  }

  if (/^\/blog\/[^/]+$/i.test(p) && lang === "it") {
    const slug = p.split("/").pop() || ""
    const label = capitalizeWords(slugToLabel(slug))

    return {
      title: `${label} | Blog Ponteggi Italia | ACHI`,
      description: `Leggi l'articolo ${slugToLabel(slug)} sul blog ACHI dedicato a ponteggi, sicurezza, normativa e opere provvisionali in Italia.`,
      canonical: `/it${p}`,
    }
  }

  return null
}

export const isRouteIndexable = (pathname, search = "", lang = "en") => {
  for (const pattern of NOINDEX_PATTERNS) {
    if (pattern.test(pathname)) return false
  }

  if (hasFilterParams(pathname + search)) return false

  const routeConfig = ROUTE_SEO_CONFIG[pathname]
  if (!routeConfig) {
    const dynamicSeo = buildDynamicSeo(pathname, lang)
    return dynamicSeo ? true : true
  }

  if (routeConfig.indexable === false) return false

  const langCfg = routeConfig[lang]
  if (langCfg && langCfg.indexable === false) return false

  return true
}

export const getRouteSEO = (pathname, lang = "en", search = "") => {
  const routeConfig = ROUTE_SEO_CONFIG[pathname] || {}
  const cfg = routeConfig[lang] || routeConfig.en || {}
  const defaults = DEFAULT_SEO[lang] || DEFAULT_SEO.en
  const dynamicSeo = !routeConfig[lang] && !routeConfig.en ? buildDynamicSeo(pathname, lang) : null

  return {
    title: cfg.title || dynamicSeo?.title || defaults.title,
    description: cfg.description || dynamicSeo?.description || defaults.description,
    ogImage: cfg.ogImage || dynamicSeo?.ogImage || DEFAULT_SEO.ogImage,
    canonical: cfg.canonical || dynamicSeo?.canonical || "",
    indexable: cfg.indexable !== undefined ? cfg.indexable : isRouteIndexable(pathname, search, lang),
    keywords: cfg.keywords || dynamicSeo?.keywords || "",
  }
}

export const CANONICAL_ROUTES = [
  "/",
  "/about",
  "/chi-siamo",
  "/services",
  "/servizi",
  "/projects",
  "/i-nostri-lavori",
  "/sectors",
  "/settori-applicazioni",
  "/gallery",
  "/blog",
  "/blog-post-1",
  "/blog-post-2",
  "/blog-post-3",
  "/careers",
  "/lavora-con-noi",
  "/privacy-policy",
]
